import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { updateSort, search } from '../../state/actions';
import { StateType } from '../../../state/state.types';
import { SortTypes } from '../../search.types';

const mapState = (state: StateType) => ({
  selectedSort: state.queryParams.sort,
  displayCommentariesSearch: state.queryParams.type === 'arret',
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  onSortUpdate(type: SortTypes) {
    dispatch(updateSort(type));
    dispatch(search({ reason: 'sort' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
